import { AuthFlowType, B2BProducts } from '@stytch/vanilla-js/b2b'
import { Brand, BRAND } from '@/shared/brand/brand.config'

export const SESSION_DURATION_MINUTES = 1440 // 24 hours

export const discoveryConfig = {
  products: [B2BProducts.passwords, B2BProducts.sso],
  sessionOptions: { sessionDurationMinutes: SESSION_DURATION_MINUTES },
  authFlowType: AuthFlowType.Discovery,
  directLoginForSingleMembership: {
    status: true,
    ignoreInvites: true,
    ignoreJitProvisioning: true
  }
}

export const stytchOptions = {
  endpointOptions: {
    testApiDomain: 'stytch-staging.instaleap.io',
    apiDomain: 'stytch.instaleap.io'
  }
}

export const buildDiscoveryStyles = ({ login }: Brand) => ({
  container: {
    backgroundColor: login.cardBackgroundColor,
    borderColor: login.cardBorderColor,
    borderRadius: login.radius.card,
    width: '400px'
  },
  colors: {
    primary: login.primaryColor,
    secondary: login.secondaryColor,
    success: '#52c41a',
    error: '#ff4d4f'
  },
  buttons: {
    primary: { ...login.primaryButton, borderRadius: login.radius.button },
    secondary: { ...login.secondaryButton, borderRadius: login.radius.button }
  },
  inputs: { ...login.input, borderRadius: login.radius.input },
  fontFamily: login.fontFamily,
  hideHeaderText: false,
  logo: {
    logoImageUrl: login.logoUrl
  }
})

export const discoveryStyles = buildDiscoveryStyles(BRAND)

const capitalize = (text: string) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : text)

export const buildStytchStrings = (strings: Record<string, string>, { name }: Brand): Record<string, string> => {
  if (name !== 'instacart' || !strings) return strings
  return { ...strings, 'methodDivider.text': capitalize(strings['methodDivider.text']) }
}
